
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
        size="medium"
        color="#fff"
        type="line-spin-clockwise-fade"
        [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <div class="row">
        <div class="col-12 my-4 text-left">
            <h2 class="dark-gray-text" tabindex="0">{{'alert.chat_activity' | translate}} - {{'alert.alert_number' | translate}} {{pagination.AlertId}}</h2>
        <div class="mb-3">
            <xng-breadcrumb separator=" > ">
                <ng-container *xngBreadcrumbItem="let breadcrumb">
                    <span *ngIf="breadcrumb">{{ 'breadcrumb.' + breadcrumb | translate }}</span>
                </ng-container>
            </xng-breadcrumb>
        </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 my-4 pt-2 text-right">
            <button [disabled]="chatEmpty" id="add_toggle" type="button" title="{{'general.export' | translate}}" class="btn btn-blue btn-h-blue mb-2 mr-2" (click)="openExportLog()">
                {{'general.export' | translate}}
            </button>
            <a class="custom-hyperlink" (keydown.enter)="refreshLogs()" (click)="refreshLogs()" tabindex="0"><i class="fa fa-refresh" aria-hidden="true"></i> {{'general.refresh' | translate}}</a>
        </div>
        <div class="col-12">
            <div class="card border-top"> 
                    <div class="space"></div>
                <div *ngFor="let log of logs">
                    <ul class="timeline" *ngIf="log[4]!=3" tabindex="0">
                        <li class="mb-2 pl-4">
                            <div class="row dark-gray-text"><strong>{{log[2]}}</strong></div>
                            <div class="row text-dark">
                                <span *ngIf="log[0] && log[4]!=1">{{(log[0]=="message_sent")?log[3]+" ":""}}{{"alert_activity."+log[0] | translate}}&nbsp;</span>
                                <span *ngIf="log[0] && log[4]==1">{{log[3]+" "}}{{"alert_activity."+log[0] | translate}}{{"alert_activity.image_shared" | translate}}&nbsp;</span>
                                <span class="text-left mr-4 text-break" *ngIf="log[0] && ((log[0]=='message_sent' && log[4]==0) || (log[0]!='message_sent' && log[0]!='video_available'))">{{log[1] | translate}}<span *ngIf="(log[0]!='note_created')&&(log[4]!='0'&&log[4]!='3')&&(log[1]!='')">.</span></span>    
                                <a tabindex="0" *ngIf="log[0]=='message_sent' && log[4]==1" (keydown.enter)="functionsService.openImage(log[1])" (click)="functionsService.openImage(log[1])"><img [src]="log[1]" class="rounded" width=50 height=50></a>
                                <span *ngIf="log[0]=='message_sent' && log[4]==2">{{log[1] | translate}} Lat.: {{log[6]}} Lng.: {{log[7]}}.
                                    <agm-map #AgmMap [usePanning]="true" [latitude]="log[6]" [zoom]="15" [longitude]="log[7]" [mapTypeId]="'hybrid'" fullscreenControl = true>
                                        <ng-container>
                                            <agm-marker [latitude]="log[6]" [longitude]="log[7]"></agm-marker>
                                        </ng-container>
                                    </agm-map>
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>